import React from "react";
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
      <div className="max-w-3xl bg-white shadow-lg rounded-lg p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Privacy Policy
        </h1>
        <p className="text-gray-700 mb-4">
          This Privacy Policy explains how we collect, use, and protect your
          personal information when you use our services.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mt-6">
          Information We Collect
        </h2>
        <p className="text-gray-600">
          We collect your email address only for authentication and email
          verification.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mt-6">
          How We Use Your Information
        </h2>
        <p className="text-gray-600">
          We use your email to verify your identity and provide secure access to
          our services.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mt-6">Contact Us</h2>
        <p className="text-gray-600">
          If you have any questions, contact us at{" "}
          <a
            href="mailto:support@quangphuly.online"
            className="text-blue-600 hover:underline"
          >
            support@quangphuly.online
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
